import { useEffect } from 'react';
import { SpanStatusCode, trace } from '@opentelemetry/api';

export function useReportError(error: Error & { digest?: string }, spanName: string) {
  useEffect(() => {
    // Log the error to the console for local/dev visibility.
    console.error(error);

    const tracer = trace.getTracer('ordering-frontend');
    tracer.startActiveSpan(spanName, (span) => {
      try {
        span.setAttribute('http.route', window.location?.pathname || '');
        if (error.digest) span.setAttribute('exception.digest', error.digest);
        span.recordException(error);
        span.setStatus({ code: SpanStatusCode.ERROR, message: error.message });
      } finally {
        span.end();
      }
    });
  }, [error, spanName]);
}
